var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personaliser---Necklaces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Necklaces---Customiser---main-screen---mais-op\\xE7\\xF5es---topo---lightbox",
    transform: "translate(-226.000000, -369.000000)",
    fill: "#37584F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(117.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(146.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.737931034,18.3655172 C0.635388059,18.6216977 0.695419078,18.9143412 0.890538922,19.1094611 C1.08565877,19.3045809 1.37830226,19.3646119 1.63448276,19.262069 L5.20689655,17.8344828 C9.36801641,20.4477918 14.8281184,19.5191422 17.8913221,15.6771264 C20.9545258,11.8351106 20.6436703,6.30533 17.1691701,2.83082985 C13.69467,-0.643670294 8.16488945,-0.954525792 4.3228736,2.10867788 C0.480857757,5.17188156 -0.447791774,10.6319836 2.16551724,14.7931034 L0.737931034,18.3655172 Z M2.06894795,9.65517241 C2.0696213,5.85119026 4.66333973,2.53754926 8.35582456,1.62330835 C12.0483094,0.709067443 15.8884907,2.42970683 17.6639584,5.79392962 C19.4394261,9.15815241 18.6928747,13.2994388 15.8544083,15.8319058 C13.0159418,18.3643727 8.8166616,18.6357351 5.67586207,16.4896552 C5.48496202,16.3595343 5.24158913,16.3336435 5.02758621,16.4206897 L2.6137931,17.3862069 L3.57931034,14.9724138 C3.66635646,14.7584109 3.64046573,14.515038 3.51034483,14.3241379 C2.56815515,12.9496923 2.06552297,11.3215488 2.06894795,9.65517241 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.3448276,
    cy: 9.65517241,
    r: 1.37931034
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.20689655,
    cy: 9.65517241,
    r: 1.37931034
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.4827586,
    cy: 9.65517241,
    r: 1.37931034
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6e42c977a7b3d7f26176ddedefd9c257.svg";
export { ForwardRef as ReactComponent };